import { SOURCE_TYPES } from '../constants/supplyOrdersConstants';
import {
  INTERNAL_MATERIAL_PURPOSES,
  INTERNAL_MATERIAL_PURPOSE_OPTIONS,
} from '../../constants/internalMaterialPurposes';
import {
  SUPPLY_DESTINATION_KINDS as KINDS,
  SUPPLY_DESTINATION_TEXTS as TEXTS,
} from '../constants/supplyOrderDestinationConstants';

/** Valida los campos que corresponden a una compra manual a proveedor. */
export const getSupplyOrderDestinationErrors = (form) => {
  if (form.source_type !== SOURCE_TYPES.PROVIDER || form.has_technical_origins) return {};
  if (form.destination_kind === KINDS.PROJECT) {
    return form.uuid_project ? {} : { uuid_project: TEXTS.requiredProject };
  }
  if (form.destination_kind === KINDS.INTERNAL) {
    const reason = (form.internal_reason || '').trim();
    if (!INTERNAL_MATERIAL_PURPOSE_OPTIONS.some((option) => option.value === reason)) {
      return { internal_reason: TEXTS.requiredReason };
    }
    if (reason === INTERNAL_MATERIAL_PURPOSES.OTHER) {
      const detail = (form.internal_reason_detail || '').trim();
      if (!detail) return { internal_reason_detail: TEXTS.requiredReasonDetail };
      if (detail.length > 1000) return { internal_reason_detail: TEXTS.reasonTooLong };
    }
    return {};
  }
  return { destination_kind: TEXTS.requiredKind };
};
